import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Calendar, Users, Award, BookOpen } from 'lucide-react';
import ProgramHero from './ProgramHero';
import ProgramHighlights from './ProgramHighlights';
import ProgramPartners from './ProgramPartners';

export default function CAFPProgram() {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="top" className="pt-16 bg-white">
      <ProgramHero />
      <ProgramHighlights />
      <ProgramPartners />
      
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Who Should Join?</h2>
              <ul className="space-y-4">
                {[
                  'Senior bankers from tier 1-3 financial institutions',
                  'Executives in insurance firms',
                  'Regulators, advisors, and consultants',
                  'Stakeholders in the financial sector across Africa'
                ].map((item, index) => (
                  <li key={index} className="flex items-start">
                    <Users className="h-6 w-6 text-green-600 mr-3 mt-1" />
                    <span className="text-gray-600">{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Program Benefits</h2>
              <ul className="space-y-4">
                {[
                  'Joint certificate from prestigious institutions',
                  'Expert-led training from international lecturers',
                  'Comprehensive curriculum covering key aspects',
                  'Flexible learning format with online and in-person sessions',
                  'Networking opportunities with industry professionals'
                ].map((item, index) => (
                  <li key={index} className="flex items-start">
                    <Award className="h-6 w-6 text-green-600 mr-3 mt-1" />
                    <span className="text-gray-600">{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900">Program Structure</h2>
            <p className="mt-4 text-xl text-gray-600">
              A flexible learning journey designed for working professionals
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: Calendar,
                title: '4-Month Duration',
                description: 'Flexible online learning with 3-4 hours per week commitment'
              },
              {
                icon: Users,
                title: 'In-Person Training',
                description: '2-day intensive session in Kampala, Uganda'
              },
              {
                icon: BookOpen,
                title: 'Learning Resources',
                description: '24/7 access to course materials and case studies'
              }
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white p-6 rounded-lg shadow-lg"
              >
                <item.icon className="h-8 w-8 text-green-600 mb-4" />
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}